import './Auth.scss';

import React, { Component } from 'react';
import Logger from '@KrashidBuilt/common/utils/logger';
import PropTypes from 'prop-types';

import posthog from 'posthog-js';

import { getAccessToken, getUser } from '../../api/credentials';
import { UserContext } from '../../ctx';

const logger = new Logger('Auth');

/**
 * Auth Component
 * @augments {Component<Props, State>}
 */
class Auth extends Component {
    constructor(props) {
        super(props);

        this.state = {
            working: false,
        };
    }

    componentDidMount() {
        const { working } = this.state;
        if (!working) {
            this.setState({ working: true }, async () => {
                await getAccessToken();
                const user = getUser();
                posthog.identify(user?.iId, { iId: user?.iId, cId: user?.cId, cName: user?.cName }); // identify this company in posthog
                const hasFeature = (f) => posthog.isFeatureEnabled(f);
                this.context.setUser({ ...user, hasFeature }, () => {
                    this.setState({ working: false });
                });

            });
        }
    }

    render() {
        logger.extra({ _: this });
        const { children } = this.props;
        const { working } = this.state;

        // identify this user in posthog with the FGT username

        return (
            <div className={'Auth'}>
                {!working &&
                    children
                }
            </div>
        );
    }
}

Auth.contextType = UserContext;

Auth.defaultProps = {};

Auth.propTypes = {
    children: PropTypes.shape().isRequired
};

export default Auth;
